/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employee_absences_CreateAbsenceRequest = {
    /**
     * Type of absence: VACATION, SICK, PERSONAL, TRAINING, OTHER, ACCIDENT, COMP_TIME, or CHILD_SICK
     */
    absence_type: employee_absences_CreateAbsenceRequest.absence_type;
    /**
     * ID of the employee this absence is for
     */
    employee_id: string;
    /**
     * Start date of the absence in ISO 8601 format (YYYY-MM-DD)
     */
    from_date: string;
    /**
     * Start time for partial-day absences in HH:MM format (required if full_day is false)
     */
    from_time?: string;
    /**
     * Whether this is a full-day absence (defaults to true when omitted from request)
     */
    full_day?: boolean;
    /**
     * Optional notes about the absence
     */
    notes?: string;
    /**
     * Submit as request instead of direct approval
     */
    submit_as_request?: boolean;
    /**
     * End date of the absence in ISO 8601 format (YYYY-MM-DD)
     */
    to_date: string;
    /**
     * End time for partial-day absences in HH:MM format (required if full_day is false)
     */
    to_time?: string;
};
export namespace employee_absences_CreateAbsenceRequest {
    /**
     * Type of absence: VACATION, SICK, PERSONAL, TRAINING, OTHER, ACCIDENT, COMP_TIME, or CHILD_SICK
     */
    export enum absence_type {
        VACATION = 'VACATION',
        SICK = 'SICK',
        PERSONAL = 'PERSONAL',
        TRAINING = 'TRAINING',
        OTHER = 'OTHER',
        ACCIDENT = 'ACCIDENT',
        COMP_TIME = 'COMP_TIME',
        CHILD_SICK = 'CHILD_SICK',
    }
}

